import { archivedUrl } from "./archivedUrl";
import { ssoDeliveredUrl } from "./deliveredUrl";
import { inProcessUrl } from "./inProcessUrl";
import { ssoRecycleBinUrl } from "./recycleBinUrl";
import { uploadUrl } from "./uploadUrl";
import { organizerStatusUrl } from "./organizerStatusUrl";

export class SSO {
    static readonly UPLOAD = new uploadUrl();
    static readonly ARCHIVED = new archivedUrl();
    static readonly DELIVERED = new ssoDeliveredUrl();
    static readonly IN_PROCESS = new inProcessUrl();
    static readonly RECYCLE_BIN = new ssoRecycleBinUrl();
    static readonly ORGANIZER_STATUS = new organizerStatusUrl();

}